export default "__VITE_ASSET__BbO$PxDF__"